"use client";

import { useMemo } from "react";
import type { PaginatedResultOfGetMakeupResponse } from "@/openapi/generated";
import { MakeupStatus } from "@/openapi/generated";
import { useMakeupSessionsSearch } from "./useMakeupSessionsSearch";

export function usePendingMakeupRequestsCount(enabled: boolean) {
  const filters = useMemo(
    () => ({
      status: MakeupStatus.Pending,
    }),
    [],
  );

  const { data, isPending } = useMakeupSessionsSearch({
    page: 1,
    pageSize: 1,
    filters,
    enabled,
  });

  const count = useMemo(() => {
    const raw = (data as PaginatedResultOfGetMakeupResponse | undefined)
      ?.totalCount;
    return typeof raw === "number" ? raw : Number(raw ?? 0);
  }, [data]);

  return { count, isPending };
}
